export default "__VITE_ASSET__B4O$lArB__"